<template>
  <BaseForm
    v-model="formModel"
    :schema="[
      {
        type: FormField.phoneOrEmail,
        name: 'phoneOrEmail',
        label: t('Телефон или почта'),
        attrs: {
          'placeholder': '+7 999 999-99-99',
          'data-testid': 'auth-contact-input',
        },
        required: true,
      },
      {
        type: FormField.password,
        name: 'password',
        label: t('Пароль'),
        attrs: {
          'placeholder': '***********',
          'data-testid': 'auth-password-input',
        },
        required: true,
      },
    ]"
    :when-handle-submit="handleSignin"
    class="auth-signin-form"
  >
    <template #label-password="{ value, required }">
      <div>
        {{ value }}
        <span v-if="required">*</span>
      </div>
      <div>
        <NuxtLink
          v-if="!props.onForgotPassword"
          :to="permissions.AUTH.FORGOT_PASSWORD.ROUTE"
          data-testid="open-forgot-password-btn"
        >
          {{ t('Забыли пароль?') }}
        </NuxtLink>
        <a
          v-else
          href="#"
          data-testid="open-forgot-password-btn"
          @click.prevent="props.onForgotPassword"
        >
          {{ t('Забыли пароль?') }}
        </a>
      </div>
    </template>
    <template #actions="{ nextTabindex, loading }">
      <template v-if="props.showBackButton">
        <BaseButton
          with-full
          with-decor
          data-testid="auth-prev-btn"
          @click="handleBack"
        >
          {{ t('Назад') }}
        </BaseButton>
      </template>
      <BaseButton
        :tabindex="nextTabindex"
        type="submit"
        with-full
        with-decor
        variant="primary"
        :loading="loading"
        data-testid="auth-login-btn"
      >
        {{ t('Вход') }}
      </BaseButton>
    </template>
  </BaseForm>
  <AuthContactDevelopersBlock class="auth-signin-form__developers" />
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'

import { AuthContactDevelopersBlock, useAccountStore, useAuth } from '~/entities/auth'
import { FormField, REGEX_FOR_CHECK_PHONE } from '~/shared/const'
import { permissions } from '~/shared/lib'
import { BaseButton, BaseForm } from '~/shared/ui'
import i18n from '../model/AuthSigninForm.i18n.json'

interface Props {
  showBackButton?: boolean
  onForgotPassword?: () => void
}

const props = withDefaults(defineProps<Props>(), {
  showBackButton: true,
})

const emit = defineEmits<{
  (e: 'success'): void
  (e: 'back'): void
}>()

const { t } = useI18n(i18n)
const accountStore = useAccountStore()
const { phoneOrEmail } = storeToRefs(accountStore)
const { resetAllExceptIdentifier: resetSavedForm } = accountStore
const { login } = useAuth()

const formModel = ref({ phoneOrEmail: phoneOrEmail.value, password: '' })

async function handleSignin(data: { phoneOrEmail: string, password: string }) {
  const isPhone = REGEX_FOR_CHECK_PHONE.test(data.phoneOrEmail)
  await login(data.phoneOrEmail, data.password, isPhone ? 'phone' : 'email')
  resetSavedForm()
  emit('success')
}

function handleBack() {
  emit('back')
}
</script>

<style lang="scss" scoped>
.auth-signin-form__developers {
  margin-top: rem(21px);
}
</style>
